<!--
 * @Author: your name
 * @Date: 2021-05-16 03:16:24
 * @LastEditors: 聪Cong
 * @LastEditTime: 2022-07-13 00:05:51
 * @FilePath: /卫星/weixing/src/page/dbm-to-W.vue
-->


<template>
  <div class="dbmToW">
    <Layout
      style="background: rgba(255, 255, 255, 0); height: 100%; width: 100%"
    >
      <Header style="background: rgba(255, 255, 255, 0); height: 10%"></Header>
      <Content>
        <Row class="Row" type="flex" justify="center">
          <Col flex="auto"> </Col>
          <Col flex="300px">
            <Card style="background: rgba(255, 255, 255, 0.4)">
              <p class="pbt">
                <svg
                  t="1657435615944"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1916"
                  width="25"
                  height="25"
                  style="margin-right: 10px; margin-top: 5px"
                >
                  <path
                    d="M683.52 986.88l-117.76-117.76c-30.08-30.08-78.08-30.08-108.16 0L326.4 1000.96c49.92 14.72 103.04 23.04 158.08 23.04 69.76 0 137.6-12.8 199.04-37.12zM556.8 411.52c-13.44-8.96-35.2-13.44-67.2-13.44h-38.4c-2.56 0-4.48 1.92-4.48 4.48V518.4c0 2.56 1.92 4.48 4.48 4.48h40.32c30.72 0 52.48-5.12 65.92-15.36 13.44-10.24 19.84-26.24 19.84-49.28 0-23.04-6.4-37.76-20.48-46.72z"
                    p-id="1917"
                  ></path>
                  <path
                    d="M512 0C238.08 0 16.64 222.08 16.64 495.36c0 195.84 113.92 365.44 279.04 445.44l162.56-162.56c30.08-30.08 78.08-30.08 108.16 0l162.56 162.56c165.12-80.64 279.04-249.6 279.04-445.44C1007.36 222.08 785.92 0 512 0z m75.52 536.96c-21.76 17.28-51.84 25.6-90.88 25.6h-46.08c-2.56 0-4.48 1.92-4.48 4.48v110.08c0 12.16-10.24 22.4-22.4 22.4s-22.4-10.24-22.4-22.4V380.16c0-12.16 10.24-22.4 22.4-22.4h70.4c40.96 0 71.04 7.04 91.52 21.76C609.28 396.16 620.8 422.4 620.8 457.6c1.28 34.56-10.24 61.44-33.28 79.36z m171.52-195.2c-8.32 5.12-19.84 2.56-24.96-6.4C688 260.48 604.8 211.2 511.36 211.2c-93.44 0-175.36 49.28-221.44 123.52-5.12 8.96-17.28 10.88-24.96 5.12-8.32-5.12-10.88-16-5.12-24.32C312.32 231.68 405.76 175.36 512 175.36c106.88 0 200.32 56.96 252.8 141.44 5.12 8.32 3.2 19.2-5.76 24.96z"
                    p-id="1918"
                  ></path>
                </svg>
                功率计算
              </p>
              <layout style="background: rgba(255, 255, 255, 0)">
                <!-- <p class="pbt">dbm → w</p>
                <div>
                  <Input
                    @on-search="Press_dbmTow"
                    v-model="dbmToW.dbm"
                    type="number"
                    search
                    enter-button="dbm转W"
                    placeholder="输入dbm值..."
                  />
                </div>
                <br />
                <p>dbm转w结果等于: {{ dbmToW.w }} W</p> -->
                <div>
                  <Input
                    @on-search="dBm_to_dBW_W"
                    v-model="my_form.power_dBm.value"
                    type="number"
                    search
                    enter-button="计算"
                    placeholder="输入dbm值..."
                    style="margin-top: 10px"
                  >
                    <span slot="prepend">dbm</span>
                  </Input>
                </div>
              </layout>
              <layout style="background: rgba(255, 255, 255, 0)">
                <div>
                  <Input
                    @on-search="dBW_to_dBm_W"
                    v-model="my_form.power_dBW.value"
                    type="number"
                    search
                    enter-button="计算"
                    placeholder="输入dbW值..."
                    style="margin-top: 10px"
                  >
                    <span slot="prepend">dbW</span>
                  </Input>
                </div>
              </layout>
              <layout style="background: rgba(255, 255, 255, 0)">
                <div>
                  <Input
                    @on-search="W_to_dBW_dBm"
                    v-model="my_form.power_W.value"
                    type="number"
                    search
                    enter-button="计算"
                    placeholder="输入W值..."
                    style="margin-top: 10px"
                  >
                    <span slot="prepend" style="width: 1000px">W</span>
                  </Input>
                </div>
              </layout>
            </Card>
          </Col>
          <Col flex="auto"> </Col>
        </Row>
        <Row style="margin-top: 20px" class="Row" type="flex" justify="center">
          <Col flex="auto"> </Col>
          <Col flex="300px">
            <Card style="background: rgba(255, 255, 255, 0.4)">
              <p class="pbt">
                <svg
                  t="1657436123390"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4620"
                  width="25"
                  height="25"
                  style="margin-right: 5px; margin-top: 5px"
                >
                  <path
                    d="M556.8 392.533333h-25.6V448h25.6c17.066667-2.133333 25.6-10.666667 25.6-27.733333-2.133333-17.066667-10.666667-25.6-25.6-27.733334z m177.066667-115.2H290.133333c-6.4 0-12.8 6.4-12.8 12.8v337.066667c0 6.4 6.4 12.8 12.8 12.8h443.733334c6.4 0 12.8-6.4 12.8-12.8V290.133333c0-6.4-6.4-12.8-12.8-12.8zM469.333333 522.666667c0 12.8-6.4 17.066667-19.2 17.066666s-19.2-6.4-19.2-17.066666v-145.066667c0-12.8 6.4-19.2 19.2-19.2 12.8 0 19.2 6.4 19.2 19.2v145.066667z m89.6-42.666667h-27.733333v42.666667c0 12.8-6.4 17.066667-19.2 17.066666s-19.2-6.4-19.2-17.066666v-145.066667c0-12.8 6.4-19.2 19.2-19.2h46.933333c40.533333 2.133333 61.866667 23.466667 64 61.866667-4.266667 38.4-25.6 57.6-64 59.733333zM832 106.666667H192C145.066667 106.666667 106.666667 145.066667 106.666667 192v533.333333c0 46.933333 38.4 85.333333 85.333333 85.333334h209.066667l78.933333 89.6c17.066667 19.2 46.933333 19.2 64 0l78.933333-89.6H832c46.933333 0 85.333333-38.4 85.333333-85.333334V192c0-46.933333-38.4-85.333333-85.333333-85.333333z m-21.333333 554.666666c0 23.466667-19.2 42.666667-42.666667 42.666667H256c-23.466667 0-42.666667-19.2-42.666667-42.666667V256c0-23.466667 19.2-42.666667 42.666667-42.666667h512c23.466667 0 42.666667 19.2 42.666667 42.666667v405.333333z"
                    p-id="4621"
                  ></path>
                </svg>
                IP地址计算器
              </p>
              <layout
                style="background: rgba(255, 255, 255, 0); margin-top: 10px"
              >
                <Row>
                  <Col span="7"
                    ><p style="margin-right: 5px; margin-top: 6px">
                      掩码位数:
                    </p></Col
                  >
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip.yanma"
                      maxlength="3"
                      placeholder="掩码"
                  /></Col>
                  <Col span="12"></Col>
                </Row>
              </layout>
              <layout
                style="background: rgba(255, 255, 255, 0); margin-top: 10px"
              >
                <Row>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip.w1"
                      maxlength="3"
                      placeholder="1位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip.w2"
                      maxlength="3"
                      placeholder="2位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip.w3"
                      maxlength="3"
                      placeholder="3位"
                  /></Col>
                  <Col span="11"
                    ><Input
                      @on-search="IP_jisuan"
                      v-model="jisuan_ip.w4"
                      maxlength="3"
                      placeholder="4位"
                      search
                      enter-button="IP计算"
                  /></Col>
                </Row>
              </layout>
              <layout
                v-show="ip.show"
                style="background: rgba(255, 255, 255, 0); margin-top: 10px"
              >
                <Row>
                  <Col span="7"
                    ><p style="margin-right: 5px; margin-top: 6px">
                      可用IP个数:
                    </p></Col
                  >
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.keyongIP"
                      maxlength="3"
                      placeholder="可用IP"
                  /></Col>
                  <Col span="12"></Col>
                </Row>
              </layout>

              <layout
                v-show="ip.show"
                style="background: rgba(255, 255, 255, 0); margin-top: 10px"
              >
                <Row>
                  <Col span="7"
                    ><p style="margin-right: 5px; margin-top: 6px">
                      子网掩码:
                    </p></Col
                  >
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.ziwangyanma.w1"
                      maxlength="3"
                      placeholder="1位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.ziwangyanma.w2"
                      maxlength="3"
                      placeholder="2位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.ziwangyanma.w3"
                      maxlength="3"
                      placeholder="3位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.ziwangyanma.w4"
                      maxlength="3"
                      placeholder="4位"
                  /></Col>
                </Row>
              </layout>
              <layout
                v-show="ip.show"
                style="background: rgba(255, 255, 255, 0); margin-top: 10px"
              >
                <Row>
                  <Col span="7"
                    ><p style="margin-right: 5px; margin-top: 6px">
                      网络地址:
                    </p></Col
                  >
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.wangloudizhi.w1"
                      maxlength="3"
                      placeholder="1位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.wangloudizhi.w2"
                      maxlength="3"
                      placeholder="2位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.wangloudizhi.w3"
                      maxlength="3"
                      placeholder="3位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.wangloudizhi.w4"
                      maxlength="3"
                      placeholder="4位"
                  /></Col>
                </Row>
              </layout>
              <layout
                v-show="ip.show"
                style="background: rgba(255, 255, 255, 0); margin-top: 10px"
              >
                <Row>
                  <Col span="7"
                    ><p style="margin-right: 5px; margin-top: 6px">
                      第一个IP:
                    </p></Col
                  >
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.diyigeIP.w1"
                      maxlength="3"
                      placeholder="1位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.diyigeIP.w2"
                      maxlength="3"
                      placeholder="2位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.diyigeIP.w3"
                      maxlength="3"
                      placeholder="3位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.diyigeIP.w4"
                      maxlength="3"
                      placeholder="4位"
                  /></Col>
                </Row>
              </layout>
              <layout
                v-show="ip.show"
                style="background: rgba(255, 255, 255, 0); margin-top: 10px"
              >
                <Row>
                  <Col span="7"
                    ><p style="margin-right: 5px; margin-top: 6px">
                      最后的IP:
                    </p></Col
                  >
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.zuihoudeIP.w1"
                      maxlength="3"
                      placeholder="1位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.zuihoudeIP.w2"
                      maxlength="3"
                      placeholder="2位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.zuihoudeIP.w3"
                      maxlength="3"
                      placeholder="3位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.zuihoudeIP.w4"
                      maxlength="3"
                      placeholder="4位"
                  /></Col>
                </Row>
              </layout>
              <layout
                v-show="ip.show"
                style="background: rgba(255, 255, 255, 0); margin-top: 10px"
              >
                <Row>
                  <Col span="7"
                    ><p style="margin-right: 5px; margin-top: 6px">
                      广播地址:
                    </p></Col
                  >
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.guangboIP.w1"
                      maxlength="3"
                      placeholder="1位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.guangboIP.w2"
                      maxlength="3"
                      placeholder="2位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.guangboIP.w3"
                      maxlength="3"
                      placeholder="3位"
                  /></Col>
                  <Col span="4"
                    ><Input
                      v-model="jisuan_ip_jiegou.guangboIP.w4"
                      maxlength="3"
                      placeholder="4位"
                  /></Col>
                </Row>
              </layout>
            </Card>
          </Col>
          <Col flex="auto"> </Col>
        </Row>
        <Row style="margin-top: 20px" class="Row" type="flex" justify="center">
          <Col flex="auto"> </Col>
          <Col flex="300px">
            <Card style="background: rgba(255, 255, 255, 0.4)">
              <p class="pbt">
                <svg
                  t="1657436436448"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4813"
                  width="25"
                  height="25"
                  style="margin-right: 5px; margin-top: 5px"
                >
                  <path
                    d="M512 512m-414 0a414 414 0 1 0 828 0 414 414 0 1 0-828 0Z"
                    fill="#F0C48A"
                    p-id="4814"
                  ></path>
                  <path
                    d="M415.6 688.6h192.8v152.4h-192.8z"
                    fill="#FD919E"
                    p-id="4815"
                  ></path>
                  <path
                    d="M536.2 692h72v137.2h-72zM331.4 841h361V928H331.4z"
                    fill="#E8677D"
                    p-id="4816"
                  ></path>
                  <path
                    d="M955 688.6h-886c-31.6 0-57.2-25.6-57.2-57.2V153.2C11.8 121.6 37.4 96 69 96h886c31.6 0 57.2 25.6 57.2 57.2v478.2c0 31.6-25.6 57.2-57.2 57.2z"
                    fill="#D3E6F8"
                    p-id="4817"
                  ></path>
                  <path
                    d="M944.4 688.6h-10.2V102h10.2c34 0 61.8 27.6 61.8 61.8v463.2c-0.2 34-27.8 61.6-61.8 61.6z"
                    fill="#A4CFF2"
                    p-id="4818"
                  ></path>
                  <path
                    d="M78.4 171.6h867v441.2H78.4z"
                    fill="#FFFFFF"
                    p-id="4819"
                  ></path>
                  <path
                    d="M868 174.6h72v438.4h-72z"
                    fill="#D3E6F8"
                    p-id="4820"
                  ></path>
                  <path
                    d="M955 700.4h-886c-38 0-69-31-69-69V153.2c0-38 31-69 69-69h886c38 0 69 31 69 69v478.2c0 38-31 69-69 69zM69 107.6C44 107.6 23.4 128 23.4 153.2v478.2c0 25 20.4 45.6 45.6 45.6h886c25 0 45.6-20.4 45.6-45.6V153.2c0-25-20.4-45.6-45.6-45.6h-886z"
                    fill="#4C4372"
                    p-id="4821"
                  ></path>
                  <path
                    d="M945.6 624.6H78.4c-6.4 0-11.8-5.2-11.8-11.8V171.6c0-6.4 5.2-11.8 11.8-11.8h867c6.4 0 11.8 5.2 11.8 11.8v441.2c0 6.6-5.2 11.8-11.6 11.8zM90.2 601.2h843.6V183.4H90.2v417.8zM608.4 852.6h-192.8c-6.4 0-11.8-5.2-11.8-11.8v-152.4c0-6.4 5.2-11.8 11.8-11.8h192.8c6.4 0 11.8 5.2 11.8 11.8v152.4c-0.2 6.6-5.4 11.8-11.8 11.8z m-181-23.4h169.2v-128.8h-169.2v128.8z"
                    fill="#4C4372"
                    p-id="4822"
                  ></path>
                  <path
                    d="M692.6 939.8H331.4c-6.4 0-11.8-5.2-11.8-11.8v-87c0-6.4 5.2-11.8 11.8-11.8h361c6.4 0 11.8 5.2 11.8 11.8V928c0 6.6-5.2 11.8-11.6 11.8z m-349.4-23.4h337.6v-63.6H343.2v63.6zM460 296.4c0.2-19 5-36 14-49.2 8.6-13.2 22-22.8 38.2-22.8 15.8 0 29.4 9.6 38 22.8 8.8 13.2 13.8 30.2 13.8 49.2 0 18.6-5 36-13.8 49.2-8.6 13-22.2 22.8-38 22.8-16.2 0-29.6-9.8-38.2-22.8-9-13.4-13.8-30.6-14-49.2z m81.2 0c0-14.8-4.2-27.8-9.8-36.6-6-8.6-12.8-12.8-19.2-12.6-6.4-0.2-13.4 4-19.6 12.6-5.8 8.8-9.8 21.8-9.8 36.6 0 14.6 4.2 27.8 9.8 36.4 6.2 8.8 13.2 12.8 19.6 12.8 6.4 0 13.2-4 19.2-12.8 5.6-8.8 9.8-22 9.8-36.4zM536.2 414.8V536c0 6.4-5.4 11.4-11.6 11.4-6.4 0-11.4-5-11.4-11.4v-101l-8.2 4.8c-1.8 1.2-4 1.6-5.8 1.6-4 0-7.6-2-9.6-5.8-3.4-5.2-1.6-12.4 3.6-15.4l25.2-15c0.2-0.2 0.6-0.2 0.8-0.4 0.4 0 0.6-0.4 1-0.6 0.4 0 0.8-0.2 1.2-0.2 0.2-0.2 0.6-0.2 0.8-0.2 0.4-0.2 1-0.2 1.4-0.2h2.2c0.2 0.2 0.6 0.2 0.8 0.2 0.6 0 0.8 0.2 1.2 0.4 0.2 0 0.6 0 0.8 0.2 0.6 0.4 0.8 0.6 1.2 0.6 0.2 0.2 0.4 0.4 0.8 0.6 0.2 0.2 0.6 0.4 0.8 0.6 0.4 0.2 0.6 0.6 0.8 0.8 0.2 0.2 0.4 0.4 0.6 0.8l0.8 0.8 0.2 0.4c0 0.2 0.2 0.4 0.2 0.6 0.2 0.4 0.4 0.6 0.4 1 0.2 0.4 0.2 0.8 0.4 1 0 0.4 0.2 0.8 0.2 1 0 0.6 0 1 0.4 1.4 0.8 0.4 0.8 0.6 0.8 0.8zM339.8 235.6v121.2c0 6.4-5.4 11.4-11.6 11.4-6.4 0-11.4-5-11.4-11.4v-101l-8.2 4.8c-1.8 1.2-4 1.6-5.8 1.6-4 0-7.6-2-9.6-5.8-3.4-5.2-1.6-12.4 3.6-15.4L322 226c0.2-0.2 0.6-0.2 0.8-0.4 0.4 0 0.6-0.4 1-0.6 0.4 0 0.8-0.2 1.2-0.2 0.2-0.2 0.6-0.2 0.8-0.2 0.4-0.2 1-0.2 1.4-0.2h2.2c0.2 0.2 0.6 0.2 0.8 0.2 0.6 0 0.8 0.2 1.2 0.4 0.2 0 0.6 0 0.8 0.2 0.6 0.4 0.8 0.6 1.2 0.6 0.2 0.2 0.4 0.4 0.8 0.6 0.2 0.2 0.6 0.4 0.8 0.6 0.4 0.2 0.6 0.6 0.8 0.8 0.2 0.2 0.4 0.4 0.6 0.8l0.8 0.8 0.2 0.4c0 0.2 0.2 0.4 0.2 0.6 0.2 0.4 0.4 0.6 0.4 1 0.2 0.4 0.2 0.8 0.4 1 0 0.4 0.2 0.8 0.2 1 0 0.6 0 1 0.4 1.4 0.8 0.4 0.8 0.6 0.8 0.8zM732.4 235.6v121.2c0 6.4-5.4 11.4-11.6 11.4-6.4 0-11.2-5-11.2-11.4v-101l-8.2 4.8c-1.8 1.2-4 1.6-5.8 1.6-4 0-7.6-2-9.6-5.8-3.4-5.2-1.6-12.4 3.6-15.4l25.2-15c0.2-0.2 0.6-0.2 0.8-0.4 0.4 0 0.6-0.4 1-0.6 0.4 0 0.8-0.2 1.2-0.2 0.2-0.2 0.6-0.2 0.8-0.2 0.4-0.2 1-0.2 1.4-0.2h2.2c0.2 0.2 0.6 0.2 0.8 0.2 0.6 0 0.8 0.2 1.2 0.4 0.2 0 0.6 0 0.8 0.2 0.6 0.4 0.8 0.6 1.2 0.6 0.2 0.2 0.4 0.4 0.8 0.6 0.2 0.2 0.6 0.4 0.8 0.6 0.4 0.2 0.6 0.6 0.8 0.8 0.2 0.2 0.4 0.4 0.6 0.8l0.8 0.8 0.2 0.4c0 0.2 0.2 0.4 0.2 0.6 0.2 0.4 0.4 0.6 0.4 1 0.2 0.4 0.2 0.8 0.4 1 0 0.4 0.2 0.8 0.2 1 0 0.6 0 1 0.4 1.4 0.6 0.4 0.6 0.6 0.6 0.8zM263.8 475.4c0.2-19 5-36 14-49.2 8.6-13.2 22-22.8 38.2-22.8 15.8 0 29.4 9.6 38 22.8 8.8 13.2 13.8 30.2 13.8 49.2 0 18.6-5 36-13.8 49.2-8.6 13-22.2 22.8-38 22.8-16.2 0-29.6-9.8-38.2-22.8-9-13.2-13.8-30.4-14-49.2z m81.2 0c0-14.8-4.2-27.8-9.8-36.6-6-8.6-12.8-12.8-19.2-12.6-6.4-0.2-13.4 4-19.6 12.6-5.8 8.8-9.8 21.8-9.8 36.6 0 14.6 4.2 27.8 9.8 36.4 6.2 8.8 13.2 12.8 19.6 12.8 6.4 0 13.2-4 19.2-12.8 5.6-8.6 9.8-21.8 9.8-36.4zM656.2 475.4c0.2-19 5-36 14-49.2 8.6-13.2 22-22.8 38.2-22.8 15.8 0 29.4 9.6 38 22.8 8.8 13.2 13.8 30.2 13.8 49.2 0 18.6-5 36-13.8 49.2-8.6 13-22.2 22.8-38 22.8-16.2 0-29.6-9.8-38.2-22.8-9-13.2-13.8-30.4-14-49.2z m81.2 0c0-14.8-4.2-27.8-9.8-36.6-6-8.6-12.8-12.8-19.2-12.6-6.4-0.2-13.4 4-19.6 12.6-5.8 8.8-9.8 21.8-9.8 36.6 0 14.6 4.2 27.8 9.8 36.4 6.2 8.8 13.2 12.8 19.6 12.8s13.2-4 19.2-12.8c5.8-8.6 9.8-21.8 9.8-36.4z"
                    fill="#4C4372"
                    p-id="4823"
                  ></path>
                </svg>
                进制计算器
              </p>
              <layout style="background: rgba(255, 255, 255, 0)"> </layout>
               <layout style="background: rgba(255, 255, 255, 0)">
                <!-- <p class="pbt">dbm → w</p>
                <div>
                  <Input
                    @on-search="Press_dbmTow"
                    v-model="dbmToW.dbm"
                    type="number"
                    search
                    enter-button="dbm转W"
                    placeholder="输入dbm值..."
                  />
                </div>
                <br />
                <p>dbm转w结果等于: {{ dbmToW.w }} W</p> -->
                <div>
                 此处施工中。。。。
                </div>
              </layout>
            </Card>
          </Col>
          <Col flex="auto"> </Col>
        </Row>
      </Content>
      <br />
      <Footer
        style="
          color: #000;
          background: rgba(255, 255, 255, 0);
          text-align: center;
          padding-top: 5px;
        "
      >
        <p>卫星角度计算器 ©粤ICP备666号</p>
        <p>开发者:聪Cong</p>
      </Footer>
    </Layout>
  </div>
</template>


<script>
import {
  cmd_convert_dBW2dBmW,
  cmd_convert_dBm2dBWW,
  cmd_convert_W2dBWdBm,
} from "../dbm.js";
export default {
  name: "dbmToW",
  components: {},
  data() {
    return {
      // dbmToW: {
      //   //dbm转w
      //   dbm: "", //dbm值
      //   w: "0", //w值
      // },
      // WTodbm: {
      //   //w转dbm
      //   dbm: "0", //dbm值
      //   w: "", //w值
      // },
      my_form: {
        power_dBW: {
          value: "",
        },
        power_dBm: {
          value: "",
        },
        power_W: {
          value: "",
        },
      },
      ip: {
        //控制计算结果的显示
        show: false,
      },
      jisuan_ip: {
        //计算输入的IP
        w1: "", //第一位
        w2: "", //第二位
        w3: "", //第三位
        w4: "", //第四位
        yanma: "", //掩码位数
      },
      jisuan_ip_jiegou: {
        //计算IP的结果
        ziwangyanma: {
          //计算结果，子网掩码
          w1: "", //第一位
          w2: "", //第二位
          w3: "", //第三位
          w4: "", //第四位
        },
        wangloudizhi: {
          //计算结果，网络地址
          w1: "", //第一位
          w2: "", //第二位
          w3: "", //第三位
          w4: "", //第四位
        },
        diyigeIP: {
          //计算结果，第一个IP
          w1: "", //第一位
          w2: "", //第二位
          w3: "", //第三位
          w4: "", //第四位
        },
        zuihoudeIP: {
          //计算结果，最后的IP
          w1: "", //第一位
          w2: "", //第二位
          w3: "", //第三位
          w4: "", //第四位
        },
        guangboIP: {
          //计算结果，广播IP
          w1: "", //第一位
          w2: "", //第二位
          w3: "", //第三位
          w4: "", //第四位
        },
        keyongIP: "", //计算结果，可用IP数量
      },
    };
  },
  mounted: function () {
    //生命周期钩子，实例被挂载后调用
  },
  methods: {
    //定义方法的位置
    background(type, str) {
      //提示框
      this.$Message[type]({
        background: true,
        content: str,
      });
    },
    // Press_dbmTow() {
    //   //按下dbm转w
    //   var w = Math.pow(10, this.dbmToW.dbm / 10) / 1000;
    //   if (this.dbmToW.dbm > 30) {
    //     this.dbmToW.w = w.toFixed(2);
    //   } else {
    //     this.dbmToW.w = w;
    //   }
    // },
    // Press_wTodbm() {
    //   //按下w转dbm
    //   var dbm = 10 * Math.log10((this.WTodbm.w * 1000) / 1);
    //   if (this.WTodbm.w > 0.001) {
    //     this.WTodbm.dbm = dbm.toFixed(2);
    //   } else {
    //     this.WTodbm.dbm = dbm;
    //   }
    // },
    toBinary(value) {
      //十进制转二进制
      if (isNaN(Number(value))) {
        throw `${value} is not a number`;
      }
      let bits = [];
      while (value >= 1) {
        bits.unshift(value % 2);
        value = Math.floor(value / 2);
      }
      return bits.join("");
    },
    toDecimal(value) {
      //二进制转十进制
      let bits = value.toString().split("");
      let res = 0;
      while (bits.length) {
        let bit = bits.shift();
        if (bit == 1) {
          // ** 为幂运算符，如：2**3 为 8
          res += 2 ** bits.length;
        }
      }
      return res;
    },
    BinQufang(w){     //二进制按位取反
      let w1  = this.toBinary(w)
      let qufang_w1 = "";
        for(let n =0;n<8;n++)
        {
          if(!(Number(w1.substring(n,n+1))))
          {
            qufang_w1 = qufang_w1 + "1"
          }
          else
          {
            qufang_w1 = qufang_w1 + "0"
          }
        }
      return qufang_w1
    }
    ,
    dBW_to_dBm_W() {
      if (this.my_form.power_dBW.value != "")
        cmd_convert_dBW2dBmW(this.my_form);
      else this.background("error", "请输入dbW值");
    },
    dBm_to_dBW_W() {
      if (this.my_form.power_dBm.value != "")
        cmd_convert_dBm2dBWW(this.my_form);
      else this.background("error", "请输入dbm值");
    },
    W_to_dBW_dBm() {
      if (this.my_form.power_W.value != "") cmd_convert_W2dBWdBm(this.my_form);
      else this.background("error", "请输入W值");
    },
    IP_jisuan() {
      if (
        this.jisuan_ip.w1 == "" &&
        this.jisuan_ip.w2 == "" &&
        this.jisuan_ip.w3 == "" &&
        this.jisuan_ip.w4 == "" &&
        this.jisuan_ip.yanma == ""
      ) {
        this.background("error", "请输入掩码位数和IP地址");
        return 0;
      } else {

        //子网掩码计算
        let bin = "";  //掩码计算缓存
        let num = 0;   //掩码计算每8位分一次
        let jici = 0;  //掩码计算，每8个存一次
        for (let i = 0; i < 32; i++) {
          num++;
          if (num > 7) {
            jici++;
            if (i < this.jisuan_ip.yanma) 
            bin = bin + "1";
            else 
            bin = bin + "0";
            num = 0;
            if (jici == 1)
              this.jisuan_ip_jiegou.ziwangyanma.w1 = this.toDecimal(Number(bin.slice(-8)));
            else if (jici == 2)
              this.jisuan_ip_jiegou.ziwangyanma.w2 = this.toDecimal(Number(bin.slice(-8)));
            else if (jici == 3)
              this.jisuan_ip_jiegou.ziwangyanma.w3 = this.toDecimal(Number(bin.slice(-8)));
            else if (jici == 4)
              this.jisuan_ip_jiegou.ziwangyanma.w4 = this.toDecimal(Number(bin.slice(-8)));
          } 
          else 
          {
            if (i < this.jisuan_ip.yanma) 
            bin = bin + "1";
            else 
            bin = bin + "0";
          }
        }

        //网络地址计算
        this.jisuan_ip_jiegou.wangloudizhi.w1 = this.jisuan_ip.w1&this.jisuan_ip_jiegou.ziwangyanma.w1;
        this.jisuan_ip_jiegou.wangloudizhi.w2 = this.jisuan_ip.w2&this.jisuan_ip_jiegou.ziwangyanma.w2;
        this.jisuan_ip_jiegou.wangloudizhi.w3 = this.jisuan_ip.w3&this.jisuan_ip_jiegou.ziwangyanma.w3;
        this.jisuan_ip_jiegou.wangloudizhi.w4 = this.jisuan_ip.w4&this.jisuan_ip_jiegou.ziwangyanma.w4;

        //第一个可用IP计算
        this.jisuan_ip_jiegou.diyigeIP.w1 = this.jisuan_ip_jiegou.wangloudizhi.w1;
        this.jisuan_ip_jiegou.diyigeIP.w2 = this.jisuan_ip_jiegou.wangloudizhi.w2;
        this.jisuan_ip_jiegou.diyigeIP.w3 = this.jisuan_ip_jiegou.wangloudizhi.w3;
        this.jisuan_ip_jiegou.diyigeIP.w4 = this.jisuan_ip_jiegou.wangloudizhi.w4 + 1;

        //可用IP个数
        let IP_Nub = 32 - this.jisuan_ip.yanma;
        IP_Nub = Math.pow(2, IP_Nub);  //二的IP_Nub次幂
        this.jisuan_ip_jiegou.keyongIP = IP_Nub - 2;




        //广播IP计算
        this.jisuan_ip_jiegou.guangboIP.w1 = Number(this.jisuan_ip_jiegou.wangloudizhi.w1)+ Number(this.toDecimal(this.BinQufang(this.jisuan_ip_jiegou.ziwangyanma.w1)));
        this.jisuan_ip_jiegou.guangboIP.w2 = Number(this.jisuan_ip_jiegou.wangloudizhi.w2) + Number(this.toDecimal(this.BinQufang(this.jisuan_ip_jiegou.ziwangyanma.w2)));
        this.jisuan_ip_jiegou.guangboIP.w3 = Number(this.jisuan_ip_jiegou.wangloudizhi.w3) + Number(this.toDecimal(this.BinQufang(this.jisuan_ip_jiegou.ziwangyanma.w3)));
        this.jisuan_ip_jiegou.guangboIP.w4 = Number(this.jisuan_ip_jiegou.wangloudizhi.w4) + Number(this.toDecimal(this.BinQufang(this.jisuan_ip_jiegou.ziwangyanma.w4)));


        //最后一个可用IP计算
        this.jisuan_ip_jiegou.zuihoudeIP.w1 = this.jisuan_ip_jiegou.guangboIP.w1
        this.jisuan_ip_jiegou.zuihoudeIP.w2 = this.jisuan_ip_jiegou.guangboIP.w2;
        this.jisuan_ip_jiegou.zuihoudeIP.w3 = this.jisuan_ip_jiegou.guangboIP.w3;
        this.jisuan_ip_jiegou.zuihoudeIP.w4 = this.jisuan_ip_jiegou.guangboIP.w4 - 1;
        

        this.ip.show = true; //显示计算结果
        return 0;
      }
    },
  },
};
</script>

<style>

</style>